<template>
    <div class="q-gutter-md">
        <generate-report-btn :client="client" color="primary" rounded @generated="prepend" />
        <reports-table :client-id="client.id" ref="reports" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, Report, List } from '@/type';
import GenerateReportBtn from './generate/GenerateReportBtn.vue';
import ReportsTable from './ReportsTable.vue';

export default defineComponent({
  components: { GenerateReportBtn, ReportsTable },
  props: {
    client: Object as () => Client,
  },
  methods: {
    prepend(report: Report) {
      (this.$refs.reports as List).prepend(report);
    },
  },
});
</script>
